/* eslint-disable react/require-default-props */
import React from "react";

interface Props {
  size?: "sm" | "md" | "lg";
}

const Spacer: React.FC<Props> = ({ size = "md" }: Props) => {
  const sizeToPixels = {
    sm: "5px",
    md: "10px",
    lg: "20px",
  };

  if (!Object.keys(sizeToPixels).includes(size)) {
    throw new Error(`Invalid size prop provided to <Spacer />: ${size}`);
  }

  return <div style={{ marginBottom: sizeToPixels[size] }} />;
};

export default Spacer;
